// extracted by mini-css-extract-plugin
export default {"input":"AuthInput_input__avayd"};